import { ReactNode, useEffect, useMemo, useReducer } from 'react';
import { API_ROUTERS } from '../../data';
import { useRequest } from '../../hooks';
import { storeContext } from './storeContext';

const initialState = {
  user: null,
};

const reducer = (state: any, action: { type: string; payload: any }) => {
  return action?.type in state ? { ...state, [action.type]: action?.payload } : state;
};

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const [store, dispatch] = useReducer(reducer, initialState);
  const { authRequest } = useRequest();

  useEffect(() => {
    // fetch user data after login or refresh page
    const fetchUserData = async () => {
      const { data } = await authRequest({ method: 'get', url: API_ROUTERS.VISITOR });
      setUser(data);
    };

    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setUser = (data: any) => {
    dispatch({ type: 'user', payload: data });
  };

  const value = useMemo(() => ({ store, setUser }), [store]);

  return <storeContext.Provider value={value}>{children}</storeContext.Provider>;
};
